/* eslint-disable no-console */
import {
  type ContentfulInstructorLedTraining,
  type ContentfulInstructorLedTrainingResponse,
  GET_INSTRUCTOR_LED_TRAINING,
} from 'src/graphql/queries/GetInstructorLedTraining';
import { fetchGraphQL } from 'src/services/contentful/client';

interface GetITLQueryVariables {
  slug: string;
  preview: boolean;
}

export const getILTContefulContent = async (
  slug: string,
  preview: boolean,
): Promise<ContentfulInstructorLedTraining | undefined> => {
  try {
    const response = await fetchGraphQL<ContentfulInstructorLedTrainingResponse, GetITLQueryVariables>(
      GET_INSTRUCTOR_LED_TRAINING,
      {
        slug,
        preview,
      },
    );

    return response.instructorLedTrainingCollection.items[0];
  } catch (error) {
    console.error('Error fetching ILT data:', error);

    return undefined;
  }
};
